export { default as ProfileConnectUpsellWrapper } from './ProfileConnectUpsellWrapper';
